import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  no: {
    nav: {
      links: [
        { label: "Hjem", href: "#hjem", testid: "nav-link-home" },
        { label: "Slik fungerer det", href: "#slik-fungerer-det", testid: "nav-link-how" },
        { label: "Partnere", href: "#partnere", testid: "nav-link-partners" },
        { label: "Spørsmål", href: "#faq", testid: "nav-link-faq" },
        { label: "Kontakt", href: "#kontakt", testid: "nav-link-contact" },
      ],
      cta: "Bli Partner",
      menuLabel: "Meny",
    },
    hero: {
      eyebrow: "Medlemsklubben for serveringssteder",
      lines: [
        { text: "Gjør gjester", accent: false },
        { text: "om til", accent: false },
        { text: "stamgjester.", accent: true },
      ],
      sub: "Bordverket plasserer QR-pamfletter og lignende på bordene dine. Gjestene får en belønning, som for eksempel en velkomstgave — du får en medlemsklubb som fyller bordene igjen og igjen.",
      ctaPrimary: "Bli partner",
      ctaSecondary: "Se hvordan det fungerer",
      imgAlt: "Kokk som anretter en rett i dramatisk lys",
    },
    marquee: ["Stamgjester", "Velkomstgave", "Tilbud på SMS", "Lojalitet ved bordet", "Bordverket"],
    how: {
      label: "Slik fungerer det",
      title: "Fra første besøk til en vane — i tre enkle steg.",
      steps: [
        {
          step: "Steg 01",
          title: "Skann ved bordet",
          text: "En elegant QR-pamflett på bordet byr gjesten på en gratis velkomstgave — en dessert, et glass, noe å huske.",
          imgAlt: "Vinflaske på et mørkt trebord",
        },
        {
          step: "Steg 02",
          title: "Gjesten blir medlem",
          text: "Registreringen tar sekunder, direkte fra telefonen. Restauranten bygger sin helt egen medlemsklubb — uten teknisk arbeid.",
        },
        {
          step: "Steg 03",
          title: "Vi får dem tilbake",
          text: "Personlige tilbud på SMS og e-post sendes når bordene står tomme — og gjør én enkelt visitt til en vane.",
        },
      ],
      loyalty: {
        title: "Lojalitet som smaker",
        text: "Medlemmene dine får grunner til å komme tilbake. Du får fulle bord på stille kvelder.",
        quote: "— direkte fra bordet",
        imgAlt: "Gjester rundt et bord i dempet restaurantbelysning",
      },
    },
    partners: {
      label: "Våre partnere",
      title: "Restauranter i klubben",
      body: "Møt restaurantene som gir gjestene sine noe ekstra. Som medlem får du velkomstgaver, tilbud og fordeler — direkte fra stedene du liker.",
      cardCta: "Se mer & bli medlem",
      joinTitle: "Bli vår neste partner.",
      joinBody: "Vi bygger nå Bordverkets partnernettverk — og vi gjør det sammen med restaurantene som vil være med fra starten. Er det du?",
      joinCta: "Start samtalen",
    },
    partnerPage: {
      back: "Tilbake til forsiden",
      memberTitle: "Bli medlem — helt gratis",
      memberBody: "Registrer deg og få en gratis velkomstgave ved neste besøk, pluss eksklusive tilbud på SMS og e-post.",
      name: "Navn",
      namePh: "Ola Nordmann",
      email: "E-post",
      emailPh: "deg@epost.no",
      phone: "Telefon (valgfri)",
      phonePh: "900 00 000",
      submit: "Registrer deg",
      sending: "Sender...",
      success: "Velkommen i klubben! Velkomstgaven din venter ved neste besøk.",
      error: "Noe gikk galt. Prøv igjen om litt.",
      notFound: "Finner ikke partneren.",
    },
    faq: {
      label: "Ofte stilte spørsmål",
      title: "Lurer du på noe?",
      body: "Her svarer vi på det restauranteiere oftest spør oss om. Finner du ikke svaret, er vi bare en melding unna.",
      items: [
        {
          q: "Hva koster Bordverket?",
          a: "Prisen tilpasses restaurantens størrelse og behov. De første partnerne våre får spesielt gunstige betingelser — ta kontakt for et uforpliktende tilbud.",
        },
        {
          q: "Hvordan kommer vi i gang?",
          a: "Vi leverer QR-pamfletter, vinyl stickers og lignende av høy kvalitet til bordene dine og setter opp alt det tekniske skreddersydd til din restaurant. Restauranten trenger ikke gjøre noe annet enn å ønske gjestene velkommen.",
        },
        {
          q: "Hvordan fungerer tilbudene på SMS og e-post?",
          a: "Vi sender personlige tilbud til medlemmene dine etter avtale, for eksempel på stille kvelder når bordene står tomme. Vi skreddersyr meldinger til dine behov.",
        },
        {
          q: "Må gjestene laste ned en app?",
          a: "Nei. Gjesten skanner QR-koden på bordet og registrerer seg i nettleseren på sekunder. Enklere blir det ikke.",
        },
        {
          q: "Er det bindingstid?",
          a: "Nei, vi tror på resultater, ikke kontrakter. Dere kan avslutte samarbeidet når dere vil.",
        },
      ],
    },
    contact: {
      label: "Kontakt oss",
      title: "Klar for å fylle bordene?",
      body: "Fortell oss om restauranten din, så viser vi deg hvordan Bordverket kan gjøre gjestene dine til stamgjester. Uforpliktende og helt gratis å høre fra oss.",
      fields: {
        name: "Navn",
        namePlaceholder: "Ola Nordmann",
        restaurant: "Restaurant",
        restaurantPlaceholder: "Restaurant Eksempel",
        email: "E-post",
        emailPlaceholder: "deg@restaurant.no",
        phone: "Telefon",
        phonePlaceholder: "900 00 000",
        message: "Melding",
        messagePlaceholder: "Fortell kort om restauranten din og hva du ønsker å oppnå...",
      },
      submit: "Send forespørsel",
      sending: "Sender...",
      success: "Takk for henvendelsen! Vi tar kontakt innen kort tid.",
      error: "Noe gikk galt. Prøv igjen om litt.",
      infoEmail: "E-post:",
      infoPhone: "Telefon:",
    },
    footer: {
      tagline: "Fra første besøk til faste gjester",
      copyright: "© 2026 Bordverket · bordverket.com",
    },
  },
  en: {
    nav: {
      links: [
        { label: "Home", href: "#hjem", testid: "nav-link-home" },
        { label: "How it works", href: "#slik-fungerer-det", testid: "nav-link-how" },
        { label: "Partners", href: "#partnere", testid: "nav-link-partners" },
        { label: "FAQ", href: "#faq", testid: "nav-link-faq" },
        { label: "Contact", href: "#kontakt", testid: "nav-link-contact" },
      ],
      cta: "Become a Partner",
      menuLabel: "Menu",
    },
    hero: {
      eyebrow: "The members' club for restaurants",
      lines: [
        { text: "Turn one-time", accent: false },
        { text: "guests into", accent: false },
        { text: "regulars.", accent: true },
      ],
      sub: "Bordverket places QR pamphlets and the like on your tables. Guests get a treat, such as a welcome gift — you get a members' club that fills your tables again and again.",
      ctaPrimary: "Become a partner",
      ctaSecondary: "See how it works",
      imgAlt: "Chef plating a dish in dramatic lighting",
    },
    marquee: ["Regulars", "Free welcome gift", "SMS offers", "Loyalty at the table", "Bordverket"],
    how: {
      label: "How it works",
      title: "From first visit to habit — in three simple steps.",
      steps: [
        {
          step: "Step 01",
          title: "Scan at the table",
          text: "An elegant QR pamphlet on the table treats the guest to a free welcome gift — a dessert, a glass, something to remember.",
          imgAlt: "Wine bottle on a dark wooden table",
        },
        {
          step: "Step 02",
          title: "The guest becomes a member",
          text: "Registration takes seconds, straight from the phone. Your restaurant builds its very own members' club — with zero technical work.",
        },
        {
          step: "Step 03",
          title: "We bring them back",
          text: "Personal offers by SMS and email are sent when tables sit empty — turning a single visit into a habit.",
        },
      ],
      loyalty: {
        title: "Loyalty that pays",
        text: "Your members get reasons to come back. You get full tables on quiet nights.",
        quote: "— straight from the table",
        imgAlt: "Guests around a table in dim restaurant lighting",
      },
    },
    partners: {
      label: "Our partners",
      title: "Restaurants in the club",
      body: "Meet the restaurants that give their guests something extra. As a member you get welcome gifts, offers and perks — straight from the places you love.",
      cardCta: "See more & join",
      joinTitle: "Become our next partner.",
      joinBody: "We're now building Bordverket's partner network — together with the restaurants that want in from the very start. Is it you?",
      joinCta: "Start the conversation",
    },
    partnerPage: {
      back: "Back to homepage",
      memberTitle: "Join the club — it's free",
      memberBody: "Sign up and get a free welcome gift on your next visit, plus exclusive offers by SMS and email.",
      name: "Name",
      namePh: "Jane Smith",
      email: "Email",
      emailPh: "you@email.com",
      phone: "Phone (optional)",
      phonePh: "+47 900 00 000",
      submit: "Sign up",
      sending: "Sending...",
      success: "Welcome to the club! Your welcome gift awaits on your next visit.",
      error: "Something went wrong. Please try again shortly.",
      notFound: "Partner not found.",
    },
    faq: {
      label: "Frequently asked questions",
      title: "Any questions?",
      body: "These are the questions restaurant owners ask us most. Can't find your answer? We're one message away.",
      items: [
        {
          q: "What does Bordverket cost?",
          a: "Pricing is tailored to your restaurant's size and needs. Our first partners get especially favourable terms — get in touch for a no-strings offer.",
        },
        {
          q: "How do we get started?",
          a: "We deliver ready-designed QR pamphlets for your tables and set up everything technical. All your restaurant has to do is welcome the guests.",
        },
        {
          q: "How do the SMS and email offers work?",
          a: "We send personal offers to your members when tables sit empty — on quiet evenings, for example. You always approve the content before anything goes out.",
        },
        {
          q: "Do guests need to download an app?",
          a: "No. The guest scans the QR code on the table and registers in the browser in seconds. It couldn't be simpler.",
        },
        {
          q: "Is there a lock-in period?",
          a: "No — we believe in results, not contracts. You can end the collaboration whenever you like.",
        },
      ],
    },
    contact: {
      label: "Contact us",
      title: "Ready to fill your tables?",
      body: "Tell us about your restaurant and we'll show you how Bordverket turns your guests into regulars. No commitment, and completely free to hear from us.",
      fields: {
        name: "Name",
        namePlaceholder: "Jane Smith",
        restaurant: "Restaurant",
        restaurantPlaceholder: "Restaurant Example",
        email: "Email",
        emailPlaceholder: "you@restaurant.com",
        phone: "Phone",
        phonePlaceholder: "+47 900 00 000",
        message: "Message",
        messagePlaceholder: "Tell us briefly about your restaurant and what you'd like to achieve...",
      },
      submit: "Send enquiry",
      sending: "Sending...",
      success: "Thanks for reaching out! We'll be in touch shortly.",
      error: "Something went wrong. Please try again shortly.",
      infoEmail: "Email:",
      infoPhone: "Phone:",
    },
    footer: {
      tagline: "From first visit to regulars",
      copyright: "© 2026 Bordverket · bordverket.com",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("no");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
